import React from "react";
import { connect, ConnectedProps } from "react-redux";
import { Dispatch } from "redux";
import { IStore } from "../../../../redux/store";
import KeyMetrics from "./_elements/KeyMetrics";
import LNGConsumptionChart from "./_elements/LNGConsumptionChart";
import TankTrendsChart from "./_elements/TankTrendsChart";

type OwnProps = {
	vesselId: string;
};
type VDMDashboardLNGConsumptionProps = PropsFromRedux & OwnProps;
function VDMDashboardLNGConsumption(props: VDMDashboardLNGConsumptionProps) {
	return (
		<div>
			<KeyMetrics />
			<section>
				<LNGConsumptionChart />
			</section>
			<section>
				<TankTrendsChart />
			</section>
		</div>
	);
}
function mapStateToProps(store: IStore, ownProps: OwnProps) {
	return {};
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
	return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(VDMDashboardLNGConsumption);
